import { useContext } from "react";

import {
  // AiFillHome as DarkHome,
  AiOutlineHome as LightHome,
  // AiFillQuestionCircle as DarkAbout,
  AiOutlineQuestionCircle as LightAbout,
  // AiFillCode as DarkProject,
  AiOutlineCode as LightProject,
  // AiFillPhone as DarkContact,
  AiOutlinePhone as LightContact,
} from "react-icons/ai";
import { BiMoon as DarkTheme, BiSun as LightTheme } from "react-icons/bi";
import { BiArrowBack } from "react-icons/bi";

import { ThemeContext } from "../Context/ThemeContext";
import { ScrollContext } from "../Context/ScrollContext";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const { theme, setTheme, animateBtn, setAnimateBtn, path, setPath } =
    useContext(ThemeContext);
  const { HomeRef, AboutRef, ProjectRef, ContactRef, changeLocation } =
    useContext(ScrollContext);

  // console.log(path);
  return (
    <header className="header">
      <div className="header-div">
        {!path.includes("/project/") ? (
          <>
            <button
              type="button"
              title="Home"
              aria-label="Home"
              className="transparent-btn btn-hover"
              onClick={() => changeLocation(HomeRef)}
            >
              {theme ? <LightHome /> : <LightHome />}
            </button>
            <button
              type="button"
              title="About"
              aria-label="About"
              className="transparent-btn btn-hover"
              onClick={() => changeLocation(AboutRef)}
            >
              {theme ? <LightAbout /> : <LightAbout />}
            </button>
            <button
              type="button"
              title="Projects"
              aria-label="Projects"
              className="transparent-btn btn-hover"
              onClick={() => changeLocation(ProjectRef)}
            >
              {theme ? <LightProject /> : <LightProject />}
            </button>
            <button
              type="button"
              title="Contact"
              aria-label="Contact"
              className="transparent-btn btn-hover"
              onClick={() => changeLocation(ContactRef)}
            >
              {theme ? <LightContact /> : <LightContact />}
            </button>
          </>
        ) : (
          <button
            className="go-back transparent-btn btn-hover"
            onClick={() => {
              navigate(-1);
              setPath("/");
            }}
          >
            <BiArrowBack />
          </button>
        )}
        <button
          type="button"
          title="Dark/Light Theme toggle"
          aria-label="Dark/Light Theme toggle"
          className={`transparent-btn ${
            animateBtn
              ? "animate-out"
              : animateBtn !== null
              ? "animate-in"
              : "btn-hover"
          }`}
          onClick={() => {
            setAnimateBtn(true);
          }}
          onAnimationEnd={() => {
            if (animateBtn) {
              setTheme(!theme);

              setAnimateBtn(false);
            }
          }}
        >
          {theme ? (
            <DarkTheme style={{ background: "transparent" }} />
          ) : (
            <LightTheme style={{ background: "transparent" }} />
          )}
        </button>
      </div>
    </header>
  );
};

export default Header;
